export default "__VITE_ASSET__DnnbqyLC__"